var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 18,
    viewBox: "0 0 153 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.745 0V4.83942H130.832V0H111.745ZM100.54 4.64234C101.728 4.64234 102.697 5.10219 102.697 5.69343L102.719 5.84672C102.719 6.43796 101.751 6.91971 100.584 6.91971H94.3537V4.64234H100.54ZM31.8988 6.9854L33.4619 10.073L30.3578 10.0511L31.8988 6.9854ZM111.745 6.56934V11.4088H130.832V6.56934H111.745ZM80.3305 5.38686C81.2551 5.38686 82.0036 6.10949 82.0256 7.0511V10.9708C82.0036 11.8686 81.2771 12.635 80.3525 12.635H73.8363C72.9117 12.6131 72.1632 11.8686 72.1632 10.9708V7.0511C72.1632 6.13139 72.9117 5.38686 73.8363 5.38686H80.3305ZM0 0L9.0259 18H16.797L25.8229 0H18.426L17.0391 2.78102L14.4414 7.92701L12.9004 11.0146L11.3374 7.92701L8.78374 2.78102L7.37482 0H0ZM28.0243 0L18.9984 18H26.3732L27.7601 15.219H36.0155L37.4024 18H44.7773L35.7954 0H28.0243ZM46.5164 0V18H65.8891V12.0219H53.0987L52.9886 0H46.5164ZM81.6954 0H81.6734H72.5154C69.4774 0.0218978 67.0118 2.47445 67.0118 5.47445V12.5255C67.0118 15.5255 69.4774 18 72.5154 18H81.6734C84.7114 18 87.199 15.5474 87.199 12.5255V5.47445C87.177 2.45255 84.7114 0 81.6954 0ZM88.2337 0V18H94.3096V11.9562H101.046L104.15 18H110.402L106.704 10.7299C107.804 9.76642 108.443 8.36496 108.443 6.89781V5.05839C108.443 2.27737 106.153 0 103.358 0H88.2337ZM111.745 13.1387V18H130.832V13.1387H111.745ZM135.895 0C134.178 0 132.813 1.37956 132.813 3.06569C132.791 3.15328 132.791 3.26277 132.813 3.37226V4.55474C132.813 7.0292 134.662 7.94891 137.304 9.0219L145.075 11.8467H132.769V14.9124C132.769 16.6204 134.156 18 135.851 18H149.874C151.591 18 152.978 16.6204 152.978 14.9124V13.5109C152.978 11.0365 151.129 10.1168 148.465 9.0438L140.496 6.15329H153V3.06569C153 1.35766 151.613 0 149.918 0H135.895Z",
    fill: "url(#paint0_linear_2527_18030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2527_18030",
    x1: 35.5273,
    y1: -35.3374,
    x2: 120.617,
    y2: 50.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2AAF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2DC79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2AAF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279678"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2468e7d333b9ba5244b93a65f813eb21.svg";
export { ForwardRef as ReactComponent };